__webpack_require__.p = "https://assets-01.periodica.press/7b42af8-26450874199/";